import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "ipmo_v_dbinder";

export const store = configureStore({
  reducer,
});
